// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2SabB","platform-icon":"styles_platform-icon__KNfrn","dwn-csv-wrapper":"styles_dwn-csv-wrapper__rnfoy","title":"styles_title__1OhdI"};